// extracted by mini-css-extract-plugin
export default {"PremierHero":"PremierHero_PremierHero"};